var exports = {
  "kL": "xa15a2ab7--04144c--container",
  "nf": "xa15a2ab7--04144c--link",
  "Qq": "xa15a2ab7--04144c--text",
  "UE": "xa15a2ab7--04144c--arrow",
};

module.exports = exports;
